<template>
  <el-container style="height: 100%">
    <el-header style="height: 60px; margin: 0; padding: 0; border-bottom: 1px solid">
      <h2 style="text-align: left; margin: 0">
        用户详情
        <hr />
      </h2>
    </el-header>
    <el-main>
      <el-container style="height: 100%">
        <el-aside style="width: 550px;">
          <user-detail :user-id="userId" />
        </el-aside>
        <el-main>
          <Chat :user-id="userId" />
        </el-main>
      </el-container>
    </el-main>
  </el-container>
</template>

<script>
import UserDetail from "../ui/UserDetail"

import Chat from '../ui/Chat'

export default {
  name: 'UserDetailIndex',
  components: {
    UserDetail,
    Chat
  },
  data () {
    return {
      userId: 0,
    }
  },
  created() {
    this.userId = parseInt(this.$router.currentRoute.params['uid']) || 0
  }
}
</script>



